import { ComponentView, View } from "binder"
import { ChartViewModel } from "./chart-viewModel"
import ApexCharts from "apexcharts";
import { stringIsNullOrEmpty } from "src/common/utilities";
export class ChartView extends ComponentView<ChartViewModel>{
    GetViewUniqueId(): string {
        return "V-83C2FC03-5925-4F00-8CA3-2942961B7413"
    }
    loadHtml(): string {
        let element = require('./chart.html').default;
        let style = require('./chart.less');
        return element;
    }
    constructor() {
       super();
    }

    public set backgroundStyle(v: string) { this._backgroundStyle = v; } public get backgroundStyle(): string { return this._backgroundStyle;} private _backgroundStyle: string;
    public set internalSeries(v: any) { 
        this._internalSeries = v; 
        this.renderChart();
    } public get internalSeries(): any { return this._internalSeries;} private _internalSeries: any;
    public set titlertl(v: boolean) { this._titlertl = v; } public get titlertl(): boolean { return this._titlertl;} private _titlertl: boolean;
    
    private chart : ApexCharts;
    private divElement : HTMLElement;
    public onRenderCompleted() {
        setTimeout(()=>{
            this.divElement = this.firstlevelElement.querySelector('.V-83C2FC03-5925-4F00-8CA3-2942961B7413-chart');
            this.renderChart();
        },100);    
    }
    
    private async renderChart(){
        if((this.divElement==null || this.divElement.isConnected==false)){
            this.chart?.destroy();
            this.chart = null;
            this.divElement = null;
            return;
        }
        if(this.internalSeries && this.divElement){
            let clientWidth = this.firstlevelElement.clientWidth;
            let clientHeight = this.firstlevelElement.clientHeight;
            let width = undefined;
            let height = undefined;
            if(clientWidth<clientHeight){
                width = clientWidth;
            }else{
                height = clientHeight;
            }
            this.internalSeries.chart.width = clientWidth;
            this.internalSeries.chart.height = clientHeight; 
            console.log(this.internalSeries);
            if(this.chart==null){
                this.chart = new ApexCharts(this.divElement,this.internalSeries);
                await this.chart.render();
            }else{
                await this.chart.updateOptions(this.internalSeries,true,true,false);
            }
            if(stringIsNullOrEmpty(this.backgroundStyle)==false){
                (<HTMLElement>this.firstlevelElement.querySelector(".apexcharts-canvas")).style["background-image"]=this.backgroundStyle;
            }
        }
    
        
    }
}
